import React from 'react'
import Grid from '@material-ui/core/Grid'
import UploadDropZoneContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/UploadDropZoneContainer'

const FileUploadZone = () => (
  <div className='ph8 w-100'>
    <Grid item>
      <div className='row bg-precedents-blue-10 pa6 mb6'>
        <UploadDropZoneContainer />
      </div>
    </Grid>
  </div>
)

export default FileUploadZone
